import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-signature-failled-dialog',
  templateUrl: './signature-failled-dialog.component.html',
  styleUrls: ['./signature-failled-dialog.component.scss']
})
export class SignatureFailledDialogComponent implements OnInit {

  signatureStatusText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.signatureStatusText = data.signatureStatusText;
  }

  ngOnInit(): void {
  }

}
